module.exports = __webpack_public_path__ + "img/TWD.8313faae.svg";